/**
 * App Block Positioning Handler
 * Dynamically moves the Spark Stories widget between desktop and mobile containers based on screen size
 * Note: This only targets the stories widget, NOT the carousel widget, allowing separate positioning control
 */
class AppBlockPositioning {
  constructor() {
    this.desktopContainer = null;
    this.mobileContainer = null;
    this.appContent = null;
    this.currentBreakpoint = this.getBreakpoint();
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    console.log('AppBlockPositioning: Setting up...');
    
    // Create the containers dynamically
    this.createContainers();
    
    // Wait for app content to be injected (usually takes a moment)
    this.waitForAppContent();
    
    // Listen for resize events
    window.addEventListener('resize', this.debounce(() => this.handleResize(), 250));
    
    // Initial positioning
    this.positionAppContent();
  }

  createContainers() {
    // Find the app block container
    const appBlockContainer = document.querySelector('.app-block-container');
    if (!appBlockContainer) {
      console.warn('App block container not found');
      return;
    }
    // capture containers

    this.desktopContainer = document.querySelector('.app-block-desktop');
    this.mobileContainer = document.querySelector('.app-block-mobile');
    console.log('AppBlockPositioning: Containers captured',this.desktopContainer, this.mobileContainer);
    console.log('AppBlockPositioning: Containers captured');
  }

  waitForAppContent() {
    // Check if app content exists
    const checkContent = () => {
      // Look for the spark-stories-root specifically (not the carousel)
      // Try multiple possible selectors for the stories widget
      this.appContent = document.querySelector('.spark-stories-root') || 
                        document.querySelector('.spark-shoppable-stories-root') ||
                        document.querySelector('[class*="spark-stories"]') ||
                        document.querySelector('[class*="shoppable-stories"]');
      
      if (this.appContent) {
        console.log('AppBlockPositioning: Stories widget found:', this.appContent);
        this.positionAppContent();
      } else {
        // Try again in a bit
        setTimeout(checkContent, 100);
      }
    };

    checkContent();
  }

  positionAppContent() {
    if (!this.appContent) return;

    if (window.innerWidth < 1024) {
        this.moveToMobile();
    } else {
        this.moveToDesktop();
    }
  }

  moveToDesktop() {
    if (this.appContent.parentNode === this.desktopContainer) return;
    
    console.log('AppBlockPositioning: Moving to desktop');
    
    // Move content to desktop container
    this.desktopContainer.appendChild(this.appContent);
    this.desktopContainer.style.display = 'block';
    this.mobileContainer.style.display = 'none';
  }

  moveToMobile() {
    if (this.appContent.parentNode === this.mobileContainer) return;
    
    console.log('AppBlockPositioning: Moving to mobile');
    
    // Move content to mobile container
    /**/
    console.log('AppBlockPositioning: Moving to mobile',this.mobileContainer, this.appContent);
    this.mobileContainer.appendChild(this.appContent);
    this.mobileContainer.style.display = 'block';
    this.desktopContainer.style.display = 'none';
  }

  handleResize() {
    this.positionAppContent();
  }

  getBreakpoint() {
    return window.innerWidth >= 1024 ? 'desktop' : 'mobile';
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('AppBlockPositioning: DOM ready, initializing...');
    new AppBlockPositioning();
  });
} else {
  console.log('AppBlockPositioning: DOM already ready, initializing...');
  new AppBlockPositioning();
}
